import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Calendar } from 'lucide-react';
import { Button } from './ui/button';
import { useLanguage } from '../contexts/LanguageContext';

const CTASection = () => {
  const { t, language } = useLanguage();
  
  return (
    <section className="py-20 bg-gradient-to-r from-[#84bc00] to-[#6a9600] relative overflow-hidden">
      {/* Decorative pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-full h-full" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23000000' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
        }}></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Icon */}
        <div className="inline-flex items-center justify-center w-20 h-20 bg-black rounded-full mb-8 animate-fade-in">
          <Calendar className="text-[#84bc00]" size={40} />
        </div>

        {/* Heading */}
        <h2 className="text-4xl sm:text-5xl font-black text-black mb-6 animate-fade-in-up">
          {t('cta.title1')} {t('cta.title2')}
        </h2>
        <p className="text-xl text-black/80 mb-10 max-w-3xl mx-auto animate-fade-in-up animation-delay-200">
          {t('cta.subtitle')}
        </p>

        {/* CTA Button */}
        <div className="animate-fade-in-up animation-delay-400">
          <a href="/consultation" target="_blank" rel="noopener noreferrer">
            <Button className="bg-black hover:bg-white text-[#84bc00] hover:text-black text-lg font-bold px-10 py-7 rounded-lg transition-all duration-300 hover:scale-110 hover:shadow-2xl group">
              <span>{t('cta.button')}</span>
              <ArrowRight size={20} className="ml-2 group-hover:translate-x-2 transition-transform duration-300" />
            </Button>
          </a>
        </div>

        {/* Trust badges */}
        <div className="mt-12 flex flex-wrap items-center justify-center gap-6 text-black/80 text-sm font-bold">
          <div className="flex items-center space-x-2">
            <span className="text-2xl">✓</span>
            <span>{language === 'es' ? 'SIN COMPROMISO' : 'NO COMMITMENT'}</span>
          </div>
          <div className="flex items-center space-x-2">
            <span className="text-2xl">✓</span>
            <span>{language === 'es' ? 'GUÍA EXPERTA' : 'EXPERT GUIDANCE'}</span>
          </div>
          <div className="flex items-center space-x-2">
            <span className="text-2xl">✓</span>
            <span>{language === 'es' ? 'ITINERARIO PERSONALIZADO' : 'PERSONALIZED ITINERARY'}</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
